import module$ from './module'
import url$ from './url'
import msg$ from './message'
import { hubMethod$, hubHandler$, hubFunc$ } from './signalr'

export {

    module$,
    url$,
    msg$,
    hubMethod$,
    hubHandler$,
    hubFunc$
}

export default {

    module$,
    url$,
    msg$,
    hubMethod$,
    hubHandler$,
    hubFunc$
};
